import React, { FC } from 'react';

import { NewsListProps } from './models';
import NewsListArticle from './NewsListArticle';

import './NewsList.scss';

const NewsList: FC<NewsListProps> = ({ articles, lang, readingTimeText }) => (
  <div className="news-list">
    {articles?.map((article) => (
      <NewsListArticle
        article={article}
        lang={lang}
        readingTimeText={readingTimeText}
        key={article.title}
      />
    ))}
  </div>
);

export default NewsList;
